<template>
  <div class="chatbox-wrapper chatbox" v-if="showChat" ref="chatbox">
    <div class="chat">
      <!-- system message -->
      <template v-if="notification.msgs.length && currentSession === 'SYSTEM'">
        <div class="head chatboxHead" ref="chatboxHead">
          <chat-head
            :customSysMsgName="notification.msgs"
            ref="chatHead"
          ></chat-head>
        </div>
        <div class="main chatboxMain" ref="chatContent" @scroll="scrollTopChat($event)">
          <div class="loading" :style="loadingMessage[currentSession] ?
            {} : { height: '0px', margin: '0', opacity: 0 }
          ">
            <img src="@/assets/img/chat-icon/loading-v2.svg" v-if="loadingMessage[currentSession]" />
          </div>
          <chat-item
            v-for="(item, index) in notification.msgs"
            :key="item.driver + item.taskId + item.created_time"
            :Index="index"
            :pushTextItem="item"
            :showStatus="currentSession === 'SYSTEM'"
          >
          </chat-item>
        </div>
      </template>

      <!-- 用户聊天 -->
      <template v-else>
        <div class="head chatboxHead" ref="chatboxHead">
          <chat-head ref="chatHead"></chat-head>
        </div>
        <div class="main chatboxMain" ref="chatContent" @scroll="scrollTopChat($event)">
          <div class="loading" :style="loadingMessage[currentSession] ?
            {} : { height: '0px', margin: '0', opacity: 0 }
          ">
            <img v-if="loadingMessage[currentSession]" src="@/assets/img/chat-icon/loading-v2.svg" />
          </div>
          <!-- 11 -->
          <chat-item
            v-for="(item, index) in chatList"
            :key="item.time + currentSession"
            :Index="index"
            :chatItem="item"
            :segmentationTime="segmentationTime"
            :list="chatList"
            :current-chat="currentSession"
            >{{ item.text }}
          </chat-item>
        </div>
        <div class="footer" v-if="!hideChatInput">
          <chat-input @scrollToBottom="scrollToBottom"></chat-input>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import { uniqBy } from "lodash";
import { formatDate } from "@/utils/date.js";
import chatHead from "./components/chathead.vue";
import chatItem from "./components/chatItem.vue";
import chatInput from "./components/chatInput.vue";
import chatMixins from "@/im/components/mixins/chat";
import appendToDom from "@/components-v3/mixins/append-to-dom"
import { EDIT_DRIVER_IM_UPDATE } from "@/services/push/events";
import {filterEventOb$} from "@/services/push";
import IM from "@/im/store/im";
export default {
  name: "chatbox",
  components: { chatInput, chatHead, chatItem },
  mixins: [chatMixins, appendToDom(document.getElementById('chatbox'))],
  created() {
    this.srollBottom(false);
    filterEventOb$(EDIT_DRIVER_IM_UPDATE).subscribe((data) => {
      console.log(data,'push-success');
      IM.initIMClientInstance()._getSingleList()
    })
  },
  mounted() {
    document.addEventListener("mousedown", this.startBox);

    document.addEventListener("mousemove", this.moveBox);

    document.addEventListener("mouseup", this.endBox);
  },
  methods: {
    /**
     * 点击聊天框
     */
    startBox(e) {
      // e.preventDefault();
      // e.stopPropagation();
      if (!this.dragChatbox.drag) return;
      if (this.$refs.chatboxHead && this.$refs.chatHead) {
        if (
          this.$refs.chatboxHead.contains(e.target) &&
          e.target !== this.$refs.chatHead.$refs.chatboxClose
        ) {
          const chatbox = document.querySelector('.chatbox');
          chatbox.style.userSelect = 'none';
          this.draw = true;
          this.offX = e.clientX - chatbox.offsetLeft;
          this.offY = e.clientY - chatbox.offsetTop;
          document.querySelector('.chatboxMain').style.overflow = 'hidden';
          this.throttleTime = Date.now();
        }
      }
    },
    /**
     * 移动聊天框
     */
    moveBox(e) {
      // e.preventDefault();
      // e.stopPropagation();
      if (this.draw && Date.now() - this.throttleTime > 10) {
        this.throttleTime = Date.now();
        // const chatbox = this.$refs.chatbox;
        const chatbox = document.querySelector('.chatbox');
        // let w = chatbox.getBoundingClientRect().width;
        // let h = chatbox.getBoundingClientRect().height;

        let w = 300, h = 400;

        let x = null;
        let y = null;

        let clx = e.clientX, cly = e.clientY;
        let docW = document.documentElement.clientWidth, docH = document.documentElement.clientHeight;

        if (
          clx - this.offX + w >= docW ||
          cly - this.offY + h >= docH
        ) {
          if (
            clx - this.offX + w >=
            docW
          ) {
            x = docW - w;
          }
          if (
            cly - this.offY + h >=
            docH
          ) {
            y = docH - h;
          }
        }

        if (clx - this.offX <= 72) {
          x = 72;
        }
        if (cly - this.offY <= 40 ) {
          y = 40;
        }

        if (x === null) {
          chatbox.style.left = clx - this.offX + "px";
        } else {
          chatbox.style.left = x + "px";
        }

        if (y === null) {
          chatbox.style.top = cly - this.offY + "px";
        } else {
          chatbox.style.top = y + "px";
        }
      }
    },
    /**
     * 结束移动
     */
    endBox() {
      if (this.draw) {
        this.draw = false;
        const chatbox = document.querySelector('.chatbox');
        document.querySelector('.chatboxMain').style.overflow = 'auto';
        chatbox.style.userSelect = 'text';
      }
    },

    noDrag() {
      return false;
    },

    scrollToBottom() {
      this.$nextTick(() => {
        if (this.$refs.chatContent) {
          this.$refs.chatContent.scrollTop = this.$refs.chatContent.scrollHeight - this.$refs.chatContent.clientHeight;
        }
      });
    }
  },
  computed: {
    showChat() {
      if (this.$route.path.search("message") !== -1) {
        return false;
      } else {
        return !!this.currentSession && this.dragChatbox.show;
      }
    },
  },
  watch: {
    chatList(next, prev) {
      if (!this.showChat || this.$route.path === '/message/index') return;
      if (!next || !prev) return;
      let nextSendChat = next.filter(item => !item.unsend);
      let prevSendChat = prev.filter(item => !item.unsend);
      if (next.length && prev.length && 
        nextSendChat.length === prevSendChat.length &&
        nextSendChat[0] &&
        prevSendChat[0] && 
        nextSendChat[0].time === prevSendChat[0].time && 
        nextSendChat[nextSendChat.length - 1].time === prevSendChat[prevSendChat.length - 1].time) return;
      try {
        if (next) {
          let arr = [];
          next.forEach(function (item) {
            arr.push(formatDate(item.time, "date", item.time));
          });
          //过滤的时间分割线
          this.segmentationTime = uniqBy(arr, "date");
        }
        let lastPrev = prevSendChat[prevSendChat.length - 1];
        let lastNext = nextSendChat[nextSendChat.length - 1];
        let lastConcatPrev = prev[prev.length - 1];
        let lastConcatNext = next[next.length - 1];
        if (lastPrev.time !== lastNext.time || (lastPrev.time === lastNext.time && lastConcatPrev.time !== lastConcatNext.time)) {
          this.$nextTick(() => {
            let domid = document.querySelector('#a' + lastConcatNext.time);
            domid.scrollIntoView();
          })
          
          return;
        }
        //上拉加载后反回到旧数据
        this.$nextTick(() => {
          let domid = document.querySelector("#a" + prev[0].sid);
          domid.scrollIntoView();
        })
      } catch {
        /* continue regardless of error */
      }
    },
    dragChatbox(prev) {
      this.$nextTick(() => {
        if (!this.$refs.chatbox) return;
        if (prev.bottom) {
          this.$refs.chatbox.style.bottom = prev.bottom + 'px';
        } else {
          this.$refs.chatbox.style.top = prev.top + 'px';
        }
        if (prev.right) {
          this.$refs.chatbox.style.right = prev.right + 'px';
        } else {
          this.$refs.chatbox.style.left = prev.left + 'px';
        }

        this.$refs.chatContent.scrollTop = this.$refs.chatContent.scrollHeight - this.$refs.chatContent.clientHeight;
      })
    },

    '$route'(to) {
      if (to.path !== '/message/index' && this.chatList && this.chatList.length) {
        this.$nextTick(() => {
          let domid = document.querySelector('#a' + this.chatList[this.chatList.length - 1].time);
          domid.scrollIntoView();
        })
      }
    }
  },
  beforeDestroy() {
    document.removeEventListener("mousedown", this.startBox);
    document.removeEventListener("mousemove", this.moveBox);
    document.removeEventListener("mouseup", this.endBox);
  },
};
</script>

<style lang="scss" scoped>
.chatbox-wrapper {
  width: 300px;
  height: 400px;
  position: fixed;
  right: 10px;
  bottom: 10px;
  border-radius: 8px;
  overflow: hidden;
  background: #fff;
  box-shadow: 0 6px 20px 0 rgba(0, 18, 51, 0.2);
}

.chat {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  background: #fff;

  .head {
    width: 100%;
    height: 48px;
    padding: 0 16px 0;
    display: flex;
    align-items: center;
    position: relative;
    box-shadow: inset 0 -1px 0 0 #dadce1;
  }

  .main {
    flex: 1;
    padding: 12px 16px;
    overflow-y: auto;
    background: #f0f2f5;

    .loading {
      transition: height 0.25s, opacity 0.25s;
      overflow: hidden;
      width: 100%;
      height: 37px;
      margin: 36px auto 20px;
      text-align: center;
      opacity: 1;

      img {
        animation: infinite 1s rotate ease-in-out;
      }

      @keyframes rotate {
        0% {
          transform: rotate(0deg);
        }
        100% {
          transform: rotate(360deg);
        }
      }
    }
  }

  .footer {
    width: 100%;
    max-height: 128px;
    padding: 12px 16px 16px;
    box-shadow: inset 0 1px 0 0 #dadce1;
  }
  // ::v-deep {
  //   div {
  //     user-select: text !important;
  //   }
  // }
}
</style>
